import React, {useState} from'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';



const Registration = () => {
        const [input, setInput] = useState({
          username: "",
          email: "",
          password: "",
          cpassword: ""
        });

        const handleInput=(e)=>{
            let name=e.target.name;
            let value=e.target.value;
    
            setInput({...input, [name]:value});
           
        }
        const ext_backend = process.env.REACT_APP_PORT_8000;
        

        const handlesubmit=()=>{
            let url=`${ext_backend}register/`
            axios.post(url, input,{ withCredentials: true })
               .then((res)=>{
                    // alert("Registration successful")
                    toast("Registration successful")
                    setInput({
                        username: "",
                        email: "",
                        password: "",
                        cpassword: ""
                        
                    })
                })
               .catch((error)=>{
                    console.log("error",error)
                    // alert("Registration failed")
                    toast("Registration failed")

                })
        }

  return (
<>
{/* bg-gray-900 */}
{/* <div class="w-70 backdrop-blur-lg bg-opacity-80  shadow-lg p-5 bg-[#212121] text-white"> */}
<div class="w-[100vw] h-window py-2 px-5  text-black">
  <h2 class="text-2xl font-bold pb-2 text-center">SignUp</h2>
  <div>
    <div class="mb-2">
      <label for="name" class="block mb-2 text-sm font-medium">Your name</label>
      <input
        type="text"
        id="username"
        name="username"
        class="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full py-2.5 px-4"
        placeholder="Andrew Jackson"
        required
        onChange={handleInput}
        value={input.username}
      />
    </div>
    <div className="mb-2">
      <label for="email" class="block mb-2 text-sm font-medium">Your email</label>
      <input
        type="email"
        id="email"
        name="email"
        class="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full py-2.5 px-4"
        placeholder="andrew@mail.com"
        required
        onChange={handleInput}
        value={input.email}
      />
    </div>
    <div class="mb-2">
      <label for="password" class="block mb-2 text-sm font-medium">Your password</label>
      <input
        type="password"
        id="password"
        name="password"
        class="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full py-2.5 px-4"
        placeholder="*********"
        required
        onChange={handleInput}
        value={input.password}
      />
    </div>
    <div class="mb-4">
      <label for="password" class="block mb-2 text-sm font-medium">confirm password</label>
      <input
        type="password"
        id="cpassword"
        name="cpassword"
        class="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full py-2.5 px-4"
        placeholder="*********"
        required
        onChange={handleInput}
        value={input.cpassword}
      />
    </div>
    <div>
      <p class="text-red-500 pb-2"></p>
    </div>
    <div class="flex flex-col items-center justify-between mb-4">
      <button
        onClick={handlesubmit}
        
        class="text-white bg-purple-600 hover:bg-purple-700 focus:ring-2 focus:ring-blue-300 font-medium rounded-lg text-sm mb-2 py-2.5 px-5 w-full sm:w-auto"
      >
        Register
      </button>
      <div class="flex items-center text-sm">
        <p>Already have an account?</p>
        <Link to='/Login' class="text-blue-500 hover:text-blue-700">Login</Link>
      </div>
    </div>
  </div>
</div>

</> 
 );
};

export default Registration;